import React from 'react';

import Urls from '../../../config/index';
import { message, Table, Popconfirm, Form, Row} from 'antd';
import Head from '../../utils/head';
import request from '../../utils/request';
import { paramsEncode } from '../../utils/index';
import { connect } from 'react-redux';

const FormItem = Form.Item;

let listUrl = Urls.StandardLineUrl.list;
let uploadUrl = Urls.StandardLineUrl.upload;

//export default class extends React.Component {
class StandardLine extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //total: 0,
            list: [],
            serach: {
                //page: 1,
                //pageSize: 10,
            },
            curveName: '',
        };
        this.handleRefresh = this.handleRefresh.bind(this);
        //注意这里要绑定上  在head.js中才可直接调用handDeleteResourceByIds方法
        //this.handDeleteResourceByIds = this.handDeleteResourceByIds.bind(this);
    }

    componentWillMount() {
        this.getList(listUrl + paramsEncode(this.state.serach));
    }

    getList(listUrl) {
        (async listUrl => {
            try {
                let response = await request(listUrl);

                this.setState(Object.assign(this.state, response));//reponse = {list:[object,object..]}  list对应state中的list
                
            } catch (e) {
                message.error(e.message);
            }
        })(listUrl);
    }

    confirm(record) {
        let deleteUrl = Urls.StandardLineUrl.deleteByCurveName;
        (async deleteUrl => {
            try {
                let response = await request(deleteUrl, 'post', record);
                message.success('删除成功');
                this.handleRefresh(); //删除完成重新刷新网页
                //刷新列表
            } catch (e) {
                console.log(e);
                message.error('删除失败');
            }
        })(deleteUrl);
    }

    

    serach(serach) {
        console.log("haha-search");
        //记录搜索文本
        let _serach = Object.assign(this.state.serach, serach); //page = 1
        this.setState(Object.assign(this.state, { serach: _serach }));
        (async url => {
            try {
                let response = await request(url);
                this.state.list = response;
                this.setState(Object.assign(this.state, response));
            } catch (e) {
                console.log(e);
                message.error('查询失败');
            }
        })(listUrl + paramsEncode(this.state.serach));
    }

    handleRefresh() {
        let _serach = Object.assign(this.state.serach);
        this.setState(Object.assign(this.state, { serach: _serach }));
        this.getList(listUrl + paramsEncode(this.state.serach));
        //this.state.resourceIds = [];
    }

    onSelectChange = selectedRowKeys => {
        //console.log("selectedRowKeys-value",selectedRowKeys);
        this.setState({
            resourceIds: selectedRowKeys
        })
   }

    render() {
        
        let metadata = [
            {
                type: 'Input',
                placeholder: '',
                addonBefore: '曲线名称',
                field: 'curveName',
            },
        ];
        // const propsImg = {
        //     name: 'file',
        //     action: uploadUrl,
        //     onChange(info) {
        //     alert('上传完成');
        //     window.location.reload();//强制刷新页面
        //  },
        // };
        
        
        const columns = [
            {
                title: '曲线名称',
                dataIndex: 'curveName',
                key: 'curveName',
            },
            {
                title: '操作',
                key: 'action',
                render: record => (
                    <span>
                    
                        <Popconfirm title="是否删除?" onConfirm={this.confirm.bind(this, record)}>
                            <a href="#">删除</a>
                        </Popconfirm>
                    </span>
                ),
            },
        ];
        return (
            <div>
                <h2>曲线列表</h2>
                <Row className="searchRow">
                    <Head
                        serachMeta={metadata}
                        uploadUrl={uploadUrl}
                        handleRefresh={this.handleRefresh}
                        handleSerach={this.serach.bind(this)}

                    />
                </Row>
                <Table columns={columns} dataSource={this.state.list} pagination={false} bordered  />
            </div>
        );
    }
}
export default connect()(Form.create()(StandardLine));



// WEBPACK FOOTER //
// ./components/sider/standardLine.js